import { Component, Inject, Optional, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SeoData } from '../editor.modal';
import { TemplateService } from 'src/app/services/template.service';
import { MediaSelectorComponent } from '../popups/media-selector/media-selector.component';
import { EventEmmiterService } from 'src/app/services/event-emmiter.service';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-page-edit',
  templateUrl: './page-edit.component.html',
  styleUrls: ['./page-edit.component.scss']
})
export class PageEditComponent {
  constructor(
    private dialog: MatDialogRef<PageEditComponent>,
    private templateService: TemplateService,
    private eventEmmiterService: EventEmmiterService,
    @Optional() @Inject(MAT_DIALOG_DATA) public matData,
    private _bottomSheet: MatBottomSheetRef,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData,

  ){}

  data: any;
  profileImage: any;
  isChecked: boolean = false;
  siteMapChecked: boolean= false;
  navbarButton: any = [];
  ngOnInit(){
    if(window.innerWidth > 475){
      this.data = this.matData.pageData
      this.navbarButton = this.matData.navbarButton
    }
    else{
      this.data = this.bottomSheetData.pageData
      this.navbarButton = this.bottomSheetData.navbarButton
    }

    if(!this.data.seoData){
      this.data.seoData = new SeoData();
    }
    this.isChecked = this.data.seoData.canonical === '1' ? true : false;
    this.siteMapChecked = this.data.seoData.siteMap === '1' ? true : false;
    console.log(this.data)

    this.getScreenSize()
  }

  scrWidth: number = 0;
  @HostListener('window:resize', ['$event'])
  getScreenSize(event?: any) {
    this.scrWidth = window.innerWidth;
  }

  closeTab(){
    if(this.scrWidth > 475){
      this.dialog.close();
    }
    if(this.scrWidth < 475){
      this._bottomSheet.dismiss();
    }
  }

  replaceImage(){
    let width = window.innerWidth > 475 ? '50%' : 'auto'
    let dialog = this.templateService.openDialog(
      MediaSelectorComponent,
      '90vh',
      width,
      '',
    )
    dialog.afterClosed().subscribe(
      (res:any)=>{
      this.data.seoData.image = res[0].assets[0].url;
      }
    )

  }

  deleteImage(){
    this.data.seoData.image = ''

  }

  markAsCanonical() {
    this.data.seoData.canonical = this.isChecked ? '1' : '0';
  }

  removeSiteMap(){
    this.data.seoData.siteMap = this.siteMapChecked ? '1': '0';
  }

  changeNameCheck(){
    this.data.path = '/' + this.data.pageName?.toLowerCase().replace(" ", "-");

    for(let button of this.navbarButton){
      if(button.pageId === this.data.id) {
        button.label = this.data.pageName
      }
    }
  }
}
